import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import Chat from '@/components/chat/Chat'

const ChatOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    return (
        <div>
            <Chat artData={artData} />
        </div>
    )
}

export default ChatOverview
